import { render, staticRenderFns } from "./MakerModal.vue?vue&type=template&id=72b31bf6&scoped=true"
import script from "./MakerModal.vue?vue&type=script&lang=js"
export * from "./MakerModal.vue?vue&type=script&lang=js"
import style0 from "./MakerModal.vue?vue&type=style&index=0&id=72b31bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b31bf6",
  null
  
)

export default component.exports